import { useNavigate, useParams } from "react-router-dom";
import OrganisationLayout from "../layout/OrganisationLayout";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const activityCards = [
  { label: "Platform Visits", value: "42" },
  { label: "Videos Watched", value: "116" },
  { label: "Collections Shared", value: "18" },
];

export default function OrganisationGroupsTeacherDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <OrganisationLayout>
      <Container fluid>
        <div className="heading-top mt-5 mb-2">
          <p className="organization-crumb">Organisation Group / Staff</p>
          <div className="back-page-title">
            <button onClick={() => navigate(-1)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
              >
                <path
                  d="M13.75 5.5L8.25 11L13.75 16.5"
                  stroke="#CCD2E3"
                  strokeWidth="2"
                />
              </svg>
            </button>
            <h2>Staff Detail</h2>
          </div>
        </div>

        <Row className="g-4 mt-1">
          <Col xl={5} lg={12}>
            <div className="cmn-card-color organisation-profile-card">
              <div className="student-view">
                <img
                  src={require("../../Assets/Images/girl.png")}
                  alt="Teacher avatar"
                />
                <h2>Organisation Staff Member</h2>
                <p>Cross-organisation detail preview</p>
                <p>Reference ID: {id}</p>
              </div>

              <div className="organisation-profile-grid">
                <div>
                  <span>Member Organisation</span>
                  <strong>Northgate College</strong>
                </div>
                <div>
                  <span>Group Role</span>
                  <strong>Group Collaborator</strong>
                </div>
                <div>
                  <span>Organisation Role</span>
                  <strong>Teacher</strong>
                </div>
                <div>
                  <span>Status</span>
                  <strong>Active</strong>
                </div>
              </div>
            </div>
          </Col>

          <Col xl={7} lg={12}>
            <div className="cmn-card-color organisation-actions-card">
              <div className="organisation-panel-heading">
                <div>
                  <h3>Activity summary</h3>
                  <p>
                    This screen is read-only in organisation group mode and
                    keeps restricted panels hidden.
                  </p>
                </div>
              </div>

              <div className="organisation-note-banner">
                Related Learners, Search History, and Viewing History are not
                shown in this organisation view.
              </div>

              <Row className="g-3 mt-1">
                {activityCards.map((item) => (
                  <Col md={4} key={item.label}>
                    <div className="organisation-groups-card organisation-stat-card organisation-stat-card-compact">
                      <span className="organisation-card-kicker">
                        {item.label}
                      </span>
                      <strong className="organisation-groups-stat">
                        {item.value}
                      </strong>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </OrganisationLayout>
  );
}
